// src/services/PortfolioApiService.js

/**
 * Service for handling portfolio-related API calls
 */

import { apiClient } from "../../config/api.config";

const PortfoliosService = {
  /**
   * Fetch all portfolios
   * @returns {Promise<Array>} List of portfolios
   */
  async fetchPortfolios() {
    try {
      const response = await apiClient.get("/admin/portfolios");

      if (response.data.success) {
        return response.data.data.portfolios;
      } else {
        throw new Error(response.data.message || "Failed to fetch portfolios");
      }
    } catch (error) {
      throw error;
    }
  },

  /**
   * Fetch details for a specific portfolio
   * @param {string} portfolioId - ID of the portfolio to fetch
   * @returns {Promise<Object>} Portfolio details including holdings and investment history
   */
  async fetchPortfolioDetails(portfolioId) {
    try {
      const response = await apiClient.get(`/admin/portfolios/${portfolioId}`);

      if (response.data.success) {
        return {
          portfolio: response.data.data.portfolio,
          holdings: response.data.data.holdings,
          investmentHistory: response.data.data.investmentHistory,
        };
      } else {
        throw new Error(response.data.message || "Failed to load portfolio details");
      }
    } catch (error) {
      throw error;
    }
  },
};

export default PortfoliosService;
